module.exports = __webpack_public_path__ + "static/media/react.aa1b145a.png";